export const SKU_LIST_JH001: string[] = [
"JH001-AiBl-XS",
"JH001-AiBl-S",
"JH001-AiBl-M",
"JH001-AiBl-L",
"JH001-AiBl-XL",
"JH001-AiBl-2XL",
"JH001-AiBl-3XL",
"JH001-ApGr-XS",
"JH001-ApGr-S",
"JH001-ApGr-M",
"JH001-ApGr-L",
"JH001-ApGr-XL",
"JH001-ApGr-2XL",
"JH001-ApGr-3XL",
"JH001-ArWh-XS",
"JH001-ArWh-S",
"JH001-ArWh-M",
"JH001-ArWh-L",
"JH001-ArWh-XL",
"JH001-ArWh-2XL",
"JH001-ArWh-3XL",
"JH001-ArWh-4XL",
"JH001-ArWh-5XL",
"JH001-As-XS",
"JH001-AtBl-XS",
"JH001-As-S",
"JH001-AtBl-S",
"JH001-As-M",
"JH001-AtBl-M",
"JH001-As-L",
"JH001-AtBl-L",
"JH001-As-XL",
"JH001-AtBl-XL",
"JH001-As-2XL",
"JH001-AtBl-2XL",
"JH001-As-3XL",
"JH001-AtBl-3XL",
"JH001-BaPi-XS",
"JH001-BaPi-S",
"JH001-BaPi-M",
"JH001-BaPi-L",
"JH001-BaPi-XL",
"JH001-BaPi-2XL",
"JH001-BaPi-3XL",
"JH001-BaPi-4XL",
"JH001-BaPi-5XL",
"JH001-BlSm-XS",
"JH001-BlSm-S",
"JH001-BlSm-M",
"JH001-BlSm-L",
"JH001-BlSm-XL",
"JH001-BlSm-2XL",
"JH001-BlSm-3XL",
"JH001-BoGr-XS",
"JH001-BoGr-S",
"JH001-BoGr-M",
"JH001-BoGr-L",
"JH001-BoGr-XL",
"JH001-BoGr-2XL",
"JH001-BoGr-3XL",
"JH001-BoGr-4XL",
"JH001-BoGr-5XL",
"JH001-BrRe-XS",
"JH001-BrRe-S",
"JH001-BrRe-M",
"JH001-BrRe-L",
"JH001-BrRe-XL",
"JH001-BrRe-2XL",
"JH001-BrRe-3XL",
"JH001-Bu-XS",
"JH001-Bu-S",
"JH001-Bu-M",
"JH001-Bu-L",
"JH001-Bu-XL",
"JH001-Bu-2XL",
"JH001-Bu-3XL",
"JH001-Bu-4XL",
"JH001-Bu-5XL",
"JH001-BuSm-XS",
"JH001-BuSm-S",
"JH001-BuSm-M",
"JH001-BuSm-L",
"JH001-BuSm-XL",
"JH001-BuSm-2XL",
"JH001-BuSm-3XL",
"JH001-BuOr-XS",
"JH001-BuOr-S",
"JH001-BuOr-M",
"JH001-BuOr-L",
"JH001-BuOr-XL",
"JH001-BuOr-2XL",
"JH001-BuOr-3XL",
"JH001-CaGr-XS",
"JH001-CaGr-S",
"JH001-CaGr-M",
"JH001-CaGr-L",
"JH001-CaGr-XL",
"JH001-CaGr-2XL",
"JH001-CaGr-3XL",
"JH001-CaPi-XS",
"JH001-CaPi-S",
"JH001-CaPi-M",
"JH001-CaPi-L",
"JH001-CaPi-XL",
"JH001-CaPi-2XL",
"JH001-CaPi-3XL",
"JH001-Ch-XS",
"JH001-Ch-S",
"JH001-Ch-M",
"JH001-Ch-L",
"JH001-Ch-XL",
"JH001-Ch-2XL",
"JH001-Ch-3XL",
"JH001-Ch-4XL",
"JH001-Ch-5XL",
"JH001-CoBl-XS",
"JH001-CoBl-S",
"JH001-CoBl-M",
"JH001-CoBl-L",
"JH001-CoBl-XL",
"JH001-CoBl-2XL",
"JH001-CoBl-3XL",
"JH001-Cr-XS",
"JH001-Cr-S",
"JH001-Cr-M",
"JH001-Cr-L",
"JH001-Cr-XL",
"JH001-Cr-2XL",
"JH001-Cr-3XL",
"JH001-DeSeBl-XS",
"JH001-DeSeBl-S",
"JH001-DeSeBl-M",
"JH001-DeSeBl-L",
"JH001-DeSeBl-XL",
"JH001-DeSeBl-2XL",
"JH001-DeSeBl-3XL",
"JH001-DenBl-XS",
"JH001-DenBl-S",
"JH001-DenBl-M",
"JH001-DenBl-L",
"JH001-DenBl-XL",
"JH001-DenBl-2XL",
"JH001-DenBl-3XL",
"JH001-DeSa-XS",
"JH001-DeSa-S",
"JH001-DeSa-M",
"JH001-DeSa-L",
"JH001-DeSa-XL",
"JH001-DeSa-2XL",
"JH001-DeSa-3XL",
"JH001-DuPi-XS",
"JH001-DuPi-S",
"JH001-DuPi-M",
"JH001-DuPi-L",
"JH001-DuPi-XL",
"JH001-DuPi-2XL",
"JH001-DuPi-3XL",
"JH001-FiRe-XS",
"JH001-FiRe-S",
"JH001-FiRe-M",
"JH001-FiRe-L",
"JH001-FiRe-XL",
"JH001-FiRe-2XL",
"JH001-FiRe-3XL",
"JH001-FiRe-4XL",
"JH001-FiRe-5XL",
"JH001-FoGr-XS",
"JH001-FoGr-S",
"JH001-FoGr-M",
"JH001-FoGr-L",
"JH001-FoGr-XL",
"JH001-FoGr-2XL",
"JH001-FoGr-3XL",
"JH001-Go-XS",
"JH001-Go-S",
"JH001-Go-M",
"JH001-Go-L",
"JH001-Go-XL",
"JH001-Go-2XL",
"JH001-Go-3XL",
"JH001-HaBl-XS",
"JH001-HaBl-S",
"JH001-HaBl-M",
"JH001-HaBl-L",
"JH001-HaBl-XL",
"JH001-HaBl-2XL",
"JH001-HaBl-3XL",
"JH001-HeGy-XS",
"JH001-HeGy-S",
"JH001-HeGy-M",
"JH001-HeGy-L",
"JH001-HeGy-XL",
"JH001-HeGy-2XL",
"JH001-HeGy-3XL",
"JH001-HeGy-4XL",
"JH001-HeGy-5XL",
"JH001-HoCh-XS",
"JH001-HoCh-S",
"JH001-HoCh-M",
"JH001-HoCh-L",
"JH001-HoCh-XL",
"JH001-HoCh-2XL",
"JH001-HoCh-3XL",
"JH001-HoPi-XS",
"JH001-HoPi-S",
"JH001-HoPi-M",
"JH001-HoPi-L",
"JH001-HoPi-XL",
"JH001-HoPi-2XL",
"JH001-HoPi-3XL",
"JH001-IcBl-XS",
"JH001-IcBl-S",
"JH001-IcBl-M",
"JH001-IcBl-L",
"JH001-IcBl-XL",
"JH001-IcBl-2XL",
"JH001-IcBl-3XL",
"JH001-Ja-XS",
"JH001-Ja-S",
"JH001-Ja-M",
"JH001-Ja-L",
"JH001-Ja-XL",
"JH001-Ja-2XL",
"JH001-Ja-3XL",
"JH001-JeBl-XS",
"JH001-JeBl-S",
"JH001-JeBl-M",
"JH001-JeBl-L",
"JH001-JeBl-XL",
"JH001-JeBl-2XL",
"JH001-JeBl-3XL",
"JH001-JeBl-4XL",
"JH001-JeBl-5XL",
"JH001-KeGr-XS",
"JH001-KeGr-S",
"JH001-KeGr-M",
"JH001-KeGr-L",
"JH001-KeGr-XL",
"JH001-KeGr-2XL",
"JH001-KeGr-3XL",
"JH001-Kh-XS",
"JH001-Kh-S",
"JH001-Kh-M",
"JH001-Kh-L",
"JH001-Kh-XL",
"JH001-Kh-2XL",
"JH001-Kh-3XL",
"JH001-La-XS",
"JH001-La-S",
"JH001-La-M",
"JH001-La-L",
"JH001-La-XL",
"JH001-La-2XL",
"JH001-La-3XL",
"JH001-LiOr-XS",
"JH001-LiOr-S",
"JH001-LiOr-M",
"JH001-LiOr-L",
"JH001-LiOr-XL",
"JH001-LiOr-2XL",
"JH001-LiOr-3XL",
"JH001-LiGr-XS",
"JH001-LiGr-S",
"JH001-LiGr-M",
"JH001-LiGr-L",
"JH001-LiGr-XL",
"JH001-LiGr-2XL",
"JH001-LiGr-3XL",
"JH001-LiPi-XS",
"JH001-LiPi-S",
"JH001-LiPi-M",
"JH001-LiPi-L",
"JH001-LiPi-XL",
"JH001-LiPi-2XL",
"JH001-LiPi-3XL",
"JH001-MaMa-XS",
"JH001-MaMa-S",
"JH001-MaMa-M",
"JH001-MaMa-L",
"JH001-MaMa-XL",
"JH001-MaMa-2XL",
"JH001-MaMa-3XL",
"JH001-MoBr-XS",
"JH001-MoBr-S",
"JH001-MoBr-M",
"JH001-MoBr-L",
"JH001-MoBr-XL",
"JH001-MoBr-2XL",
"JH001-MoBr-3XL",
"JH001-MoGy-XS",
"JH001-MoGy-S",
"JH001-MoGy-M",
"JH001-MoGy-L",
"JH001-MoGy-XL",
"JH001-MoGy-2XL",
"JH001-MoGy-3XL",
"JH001-MoGr-XS",
"JH001-MoGr-S",
"JH001-MoGr-M",
"JH001-MoGr-L",
"JH001-MoGr-XL",
"JH001-MoGr-2XL",
"JH001-MoGr-3XL",
"JH001-Mu-XS",
"JH001-Mu-S",
"JH001-Mu-M",
"JH001-Mu-L",
"JH001-Mu-XL",
"JH001-Mu-2XL",
"JH001-Mu-3XL",
"JH001-NaCl-XS",
"JH001-NaCl-S",
"JH001-NaCl-M",
"JH001-NaCl-L",
"JH001-NaCl-XL",
"JH001-NaCl-2XL",
"JH001-NaCl-3XL",
"JH001-NaSm-XS",
"JH001-NaSm-S",
"JH001-NaSm-M",
"JH001-NaSm-L",
"JH001-NaSm-XL",
"JH001-NaSm-2XL",
"JH001-NaSm-3XL",
"JH001-NeFrNa-XS",
"JH001-NeFrNa-S",
"JH001-NeFrNa-M",
"JH001-NeFrNa-L",
"JH001-NeFrNa-XL",
"JH001-NeFrNa-2XL",
"JH001-NeFrNa-3XL",
"JH001-NeFrNa-4XL",
"JH001-NeFrNa-5XL",
"JH001-Nu-XS",
"JH001-Nu-S",
"JH001-Nu-M",
"JH001-Nu-L",
"JH001-Nu-XL",
"JH001-Nu-2XL",
"JH001-Nu-3XL",
"JH001-OlGr-XS",
"JH001-OlGr-S",
"JH001-OlGr-M",
"JH001-OlGr-L",
"JH001-OlGr-XL",
"JH001-OlGr-2XL",
"JH001-OlGr-3XL",
"JH001-OrCr-XS",
"JH001-OrCr-S",
"JH001-OrCr-M",
"JH001-OrCr-L",
"JH001-OrCr-XL",
"JH001-OrCr-2XL",
"JH001-OrCr-3XL",
"JH001-PePe-XS",
"JH001-PePe-S",
"JH001-PePe-M",
"JH001-PePe-L",
"JH001-PePe-XL",
"JH001-PePe-2XL",
"JH001-PePe-3XL",
"JH001-OxNa-XS",
"JH001-OxNa-S",
"JH001-OxNa-M",
"JH001-OxNa-L",
"JH001-OxNa-XL",
"JH001-OxNa-2XL",
"JH001-OxNa-3XL",
"JH001-OxNa-4XL",
"JH001-OxNa-5XL",
"JH001-Pe-XS",
"JH001-Pe-S",
"JH001-Pe-M",
"JH001-Pe-L",
"JH001-Pe-XL",
"JH001-Pe-2XL",
"JH001-Pe-3XL",
"JH001-PiCo-XS",
"JH001-PiCo-S",
"JH001-PiCo-M",
"JH001-PiCo-L",
"JH001-PiCo-XL",
"JH001-PiCo-2XL",
"JH001-PiCo-3XL",
"JH001-PiPu-XS",
"JH001-PiPu-S",
"JH001-PiPu-M",
"JH001-PiPu-L",
"JH001-PiPu-XL",
"JH001-PiPu-2XL",
"JH001-PiPu-3XL",
"JH001-PiGr-XS",
"JH001-PiGr-S",
"JH001-PiGr-M",
"JH001-PiGr-L",
"JH001-PiGr-XL",
"JH001-PiGr-2XL",
"JH001-PiGr-3XL",
"JH001-PlGr-XS",
"JH001-PlGr-S",
"JH001-PlGr-M",
"JH001-PlGr-L",
"JH001-PlGr-XL",
"JH001-PlGr-2XL",
"JH001-PlGr-3XL",
"JH001-Pl-XS",
"JH001-Pl-S",
"JH001-Pl-M",
"JH001-Pl-L",
"JH001-Pl-XL",
"JH001-Pl-2XL",
"JH001-Pl-3XL",
"JH001-Pu-XS",
"JH001-Pu-S",
"JH001-Pu-M",
"JH001-Pu-L",
"JH001-Pu-XL",
"JH001-Pu-2XL",
"JH001-Pu-3XL",
"JH001-Pu-4XL",
"JH001-Pu-5XL",
"JH001-RaGr-XS",
"JH001-RaGr-S",
"JH001-RaGr-M",
"JH001-RaGr-L",
"JH001-RaGr-XL",
"JH001-RaGr-2XL",
"JH001-RaGr-3XL",
"JH001-ReHoCh-XS",
"JH001-ReHoCh-S",
"JH001-ReHoCh-M",
"JH001-ReHoCh-L",
"JH001-ReHoCh-XL",
"JH001-ReHoCh-2XL",
"JH001-ReHoCh-3XL",
"JH001-RoBl-XS",
"JH001-RoBl-S",
"JH001-RoBl-M",
"JH001-RoBl-L",
"JH001-RoBl-XL",
"JH001-RoBl-2XL",
"JH001-RoBl-3XL",
"JH001-RoBl-4XL",
"JH001-RoBl-5XL",
"JH001-SaBl-XS",
"JH001-SaBl-S",
"JH001-SaBl-M",
"JH001-SaBl-L",
"JH001-SaBl-XL",
"JH001-SaBl-2XL",
"JH001-SaBl-3XL",
"JH001-SaBl-4XL",
"JH001-SaBl-5XL",
"JH001-ShLe-XS",
"JH001-ShLe-S",
"JH001-ShLe-M",
"JH001-ShLe-L",
"JH001-ShLe-XL",
"JH001-ShLe-2XL",
"JH001-ShLe-3XL",
"JH001-SkBl-XS",
"JH001-SkBl-S",
"JH001-SkBl-M",
"JH001-SkBl-L",
"JH001-SkBl-XL",
"JH001-SkBl-2XL",
"JH001-SkBl-3XL",
"JH001-SkBl-4XL",
"JH001-SkBl-5XL",
"JH001-SpGr-XS",
"JH001-SpGr-S",
"JH001-SpGr-M",
"JH001-SpGr-L",
"JH001-SpGr-XL",
"JH001-SpGr-2XL",
"JH001-SpGr-3XL",
"JH001-SteGy-XS",
"JH001-SteGy-S",
"JH001-SteGy-M",
"JH001-SteGy-L",
"JH001-SteGy-XL",
"JH001-SteGy-2XL",
"JH001-SteGy-3XL",
"JH001-StoGy-XS",
"JH001-StoGy-S",
"JH001-StoGy-M",
"JH001-StoGy-L",
"JH001-StoGy-XL",
"JH001-StoGy-2XL",
"JH001-StoGy-3XL",
"JH001-SuYe-XS",
"JH001-SuYe-S",
"JH001-SuYe-M",
"JH001-SuYe-L",
"JH001-SuYe-XL",
"JH001-SuYe-2XL",
"JH001-SuYe-3XL",
"JH001-SuOr-XS",
"JH001-SuOr-S",
"JH001-SuOr-M",
"JH001-SuOr-L",
"JH001-SuOr-XL",
"JH001-SuOr-2XL",
"JH001-SuOr-3XL",
"JH001-TrBl-XS",
"JH001-TrBl-S",
"JH001-TrBl-M",
"JH001-TrBl-L",
"JH001-TrBl-XL",
"JH001-TrBl-2XL",
"JH001-TrBl-3XL",
"JH001-TrVi-XS",
"JH001-TrVi-S",
"JH001-TrVi-M",
"JH001-TrVi-L",
"JH001-TrVi-XL",
"JH001-TrVi-2XL",
"JH001-TrVi-3XL",
"JH001-UlVi-XS",
"JH001-UlVi-S",
"JH001-UlVi-M",
"JH001-UlVi-L",
"JH001-UlVi-XL",
"JH001-UlVi-2XL",
"JH001-UlVi-3XL",
"JH001-VaMi-XS",
"JH001-VaMi-S",
"JH001-VaMi-M",
"JH001-VaMi-L",
"JH001-VaMi-XL",
"JH001-VaMi-2XL",
"JH001-VaMi-3XL",
"JH001-WiMu-XS",
"JH001-WiMu-S",
"JH001-WiMu-M",
"JH001-WiMu-L",
"JH001-WiMu-XL",
"JH001-WiMu-2XL",
"JH001-WiMu-3XL",
"JH001-TuSu-XS",
"JH001-TuSu-S",
"JH001-TuSu-M",
"JH001-TuSu-L",
"JH001-TuSu-XL",
"JH001-TuSu-2XL",
"JH001-TuSu-3XL",
"JH001-CaTo-XS",
"JH001-CaTo-S",
"JH001-CaTo-M",
"JH001-CaTo-L",
"JH001-CaTo-XL",
"JH001-CaTo-2XL",
"JH001-CaTo-3XL",
"JH001-CoGr-XS",
"JH001-CoGr-S",
"JH001-CoGr-M",
"JH001-CoGr-L",
"JH001-CoGr-XL",
"JH001-CoGr-2XL",
"JH001-CoGr-3XL",
"JH001-DuBl-XS",
"JH001-DuBl-S",
"JH001-DuBl-M",
"JH001-DuBl-L",
"JH001-DuBl-XL",
"JH001-DuBl-2XL",
"JH001-DuBl-3XL",
"JH001-DuPu-XS",
"JH001-DuPu-S",
"JH001-DuPu-M",
"JH001-DuPu-L",
"JH001-DuPu-XL",
"JH001-DuPu-2XL",
"JH001-DuPu-3XL",
"JH001-InBl-XS",
"JH001-InBl-S",
"JH001-InBl-M",
"JH001-InBl-L",
"JH001-InBl-XL",
"JH001-InBl-2XL",
"JH001-InBl-3XL",
"JH001-DeeBl-XS",
"JH001-DeeBl-S",
"JH001-DeeBl-M",
"JH001-DeeBl-L",
"JH001-DeeBl-XL",
"JH001-DeeBl-2XL",
"JH001-DeeBl-3XL",
"JH001-DeeBl-4XL",
"JH001-DeeBl-5XL",
"JH001-ReRu-XS",
"JH001-ReRu-S",
"JH001-ReRu-M",
"JH001-ReRu-L",
"JH001-ReRu-XL",
"JH001-ReRu-2XL",
"JH001-ReRu-3XL",
"JH001-DeGr-XS",
"JH001-DeGr-S",
"JH001-DeGr-M",
"JH001-DeGr-L",
"JH001-DeGr-XL",
"JH001-DeGr-2XL",
"JH001-DeGr-3XL",
"JH001-ShGr-XS",
"JH001-ShGr-S",
"JH001-ShGr-M",
"JH001-ShGr-L",
"JH001-ShGr-XL",
"JH001-ShGr-2XL",
"JH001-ShGr-3XL",
"JH001-CaLa-XS",
"JH001-CaLa-S",
"JH001-CaLa-M",
"JH001-CaLa-L",
"JH001-CaLa-XL",
"JH001-CaLa-2XL",
"JH001-CaLa-3XL",
"JH001-DuRo-XS",
"JH001-DuRo-S",
"JH001-DuRo-M",
"JH001-DuRo-L",
"JH001-DuRo-XL",
"JH001-DuRo-2XL",
"JH001-DuRo-3XL",
"JH001-GiBi-XS",
"JH001-GiBi-S",
"JH001-GiBi-M",
"JH001-GiBi-L",
"JH001-GiBi-XL",
"JH001-GiBi-2XL",
"JH001-GiBi-3XL",
"JH001-EaGr-XS",
"JH001-EaGr-S",
"JH001-EaGr-M",
"JH001-EaGr-L",
"JH001-EaGr-XL",
"JH001-EaGr-2XL",
"JH001-EaGr-3XL",
"JH001-PuPi-XS",
"JH001-PuPi-S",
"JH001-PuPi-M",
"JH001-PuPi-L",
"JH001-PuPi-XL",
"JH001-PuPi-2XL",
"JH001-PuPi-3XL",
"JH001-DiLa-XS",
"JH001-DiLa-S",
"JH001-DiLa-M",
"JH001-DiLa-L",
"JH001-DiLa-XL",
"JH001-DiLa-2XL",
"JH001-DiLa-3XL",
"JH001-ChFuBr-XS",
"JH001-ChFuBr-S",
"JH001-ChFuBr-M",
"JH001-ChFuBr-L",
"JH001-ChFuBr-XL",
"JH001-ChFuBr-2XL",
"JH001-ChFuBr-3XL",
"JH001-DuLi-XS",
"JH001-DuLi-S",
"JH001-DuLi-M",
"JH001-DuLi-L",
"JH001-DuLi-XL",
"JH001-DuLi-2XL",
"JH001-DuLi-3XL",
"JH001-FeFu-XS",
"JH001-FeFu-S",
"JH001-FeFu-M",
"JH001-FeFu-L",
"JH001-FeFu-XL",
"JH001-FeFu-2XL",
"JH001-FeFu-3XL",
"JH001-GrHe-XS",
"JH001-GrHe-S",
"JH001-GrHe-M",
"JH001-GrHe-L",
"JH001-GrHe-XL",
"JH001-GrHe-2XL",
"JH001-GrHe-3XL",
"JH001-NaSt-XS",
"JH001-NaSt-S",
"JH001-NaSt-M",
"JH001-NaSt-L",
"JH001-NaSt-XL",
"JH001-NaSt-2XL",
"JH001-NaSt-3XL",
"JH001-LaBl-XS",
"JH001-LaBl-S",
"JH001-LaBl-M",
"JH001-LaBl-L",
"JH001-LaBl-XL",
"JH001-LaBl-2XL",
"JH001-LaBl-3XL",
"JH001-BrRo-XS",
"JH001-BrRo-S",
"JH001-BrRo-M",
"JH001-BrRo-L",
"JH001-BrRo-XL",
"JH001-BrRo-2XL",
"JH001-BrRo-3XL",
"JH001-Ci-XS",
"JH001-Ci-S",
"JH001-Ci-M",
"JH001-Ci-L",
"JH001-Ci-XL",
"JH001-Ci-2XL",
"JH001-Ci-3XL",
"JH001-Se-XS",
"JH001-Se-S",
"JH001-Se-M",
"JH001-Se-L",
"JH001-Se-XL",
"JH001-Se-2XL",
"JH001-Se-3XL",
"JH001-SoRe-XS",
"JH001-SoRe-S",
"JH001-SoRe-M",
"JH001-SoRe-L",
"JH001-SoRe-XL",
"JH001-SoRe-2XL",
"JH001-SoRe-3XL"
]